<template>
    <div>
        <Header :title="title">
            <template slot="right">
                <div class="mybarRight" v-on:click="toSearch">
                    <span class="iconfont icon-sousuo f12 color_999" />
                </div>
            </template>
        </Header>

        <main class="MainCon bottom0 rel rankBg" id="MainCon">
            <template v-if="app.template.type === '92fanli'">
                <div class="myimg rankBannerImg"><img src="../assets/images/rankBannerImg.png" />
                </div>

                <div class="rankTop">
                    <div class="ml5 mr5">
                        <div class="flexBox rankBoxBlock">
                            <div class="flexBox-cell-25" v-for="(item, key) in typeMap"
                                 :key="key" :class="{'rankBlockCur':type === key}"
                                 v-on:click="typeListTab(key)">{{item.title}}
                            </div>
                        </div>
                    </div>
                </div>
                <NTfanliTopRealLIst
                        :style-name="app.template.style"
                        :list="goodsData.list"
                        :is-more="goodsData.isMore"
                        v-on:loadMore="fetchGoodsList"
                        ref="goodsList" />
            </template>
            <template v-else-if="app.template.type === 'damai'">
                <div class="myimg rankBannerImg"><img src="../assets/images/rankBannerImg.png" />
                </div>
                <div class="rankTop">
                    <div class="ml5 mr5">
                        <div class="flexBox rankBoxBlock">
                            <div class="flexBox-cell-25" v-for="(item, key) in typeMap"
                                 :key="key" :class="{'rankBlockCur':type === key}"
                                 v-on:click="typeListTab(key)">{{item.title}}
                            </div>
                        </div>
                    </div>
                </div>

                <DamaiTopRealLIst
                        :style-name="app.template.style"
                        :list="goodsData.list"
                        :is-more="goodsData.isMore"
                        v-on:loadMore="fetchGoodsList"
                        ref="goodsList" />
            </template>
            <template v-else>
                <div class="myimg rankBannerImg"><img src="@/assets/images/rankBannerBg.jpg" />
                </div>
                <div class="rankTop">
                    <div class="ml5 mr5">
                        <div class="flexBox rankBoxBlock">
                            <div class="flexBox-cell-25" v-for="(item, key) in typeMap"
                                 :key="key" :class="{'rankBlockCur':type === key}"
                                 v-on:click="typeListTab(key)">{{item.title}}
                            </div>
                        </div>
                    </div>
                </div>
                <IfanliTopRealLIst
                        :style-name="app.template.style"
                        :list="goodsData.list"
                        :is-more="goodsData.isMore"
                        v-on:loadMore="fetchGoodsList"
                        ref="goodsList" />
            </template>
        </main>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import IfanliTopRealLIst from './ifanli/TopRealLIst';
    import NTfanliTopRealLIst from './92fanli/TopRealLIst';
    import DamaiTopRealLIst from './damai/TopRealLIst';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    export default {
        components: {IfanliTopRealLIst, NTfanliTopRealLIst, DamaiTopRealLIst, Header},
        data() {
            return {
                title: '实时榜单',
                typeMap: {
                    real: {title: '实时榜'},
                    today: {title: '今日榜'},
                    yesterday: {title: '昨日榜'},
                    order: {title: '出单榜'},
                },
                goodsData: {
                    status: false,
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 1
                },
                type: 'real'
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/goods/real';
            }

            this.fetchGoodsList({init: true});
        },
        methods: {
            fetchGoodsList: function ({init = false} = {}) {
                let self = this;

                if (self.goodsData.isMore === true && self.goodsData.loading === false) {
                    self.goodsData.loading = true;
                    appService.fetchRealGoodsList({
                        pageNum: self.goodsData.pageNum,
                        type: self.type
                    }).then((res) => {
                        let {code, data} = res;
                        if (code === 200) {
                            if (data.length > 0) {
                                if (init) {
                                    self.$refs.goodsList.toTop(0);
                                    self.goodsData.list = data;
                                } else {
                                    for (let i = 0; i < data.length; i++) {
                                        self.goodsData.list.push(data[i]);
                                    }
                                }
                                self.goodsData.isMore = true;
                                self.goodsData.pageNum++;
                            } else {
                                self.goodsData.isMore = false;
                            }
                        }
                        self.goodsData.loading = false;
                    });
                }
            },
            typeListTab: function (index) {
                this.type = index;
                this.fetchGoodsList({init: true});
            },
            toSearch: function () {
                this.$router.push({name: 'search'});
            }
        }
    }
</script>

<style scoped>

</style>
